(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('openresaRightsService', openresaRightsService);

    function openresaRightsService (swif) {
        'ngInject';
        var service = {};
        service.getUserAbility = getUserAbility;

        function getUserAbility (container) {
            var user = swif.user.getAuthenticatedUserData();
            container = container ? container : {};
            container.is = {
                manager: _.contains(user.access_rights, 'HOTEL_MANA'),
                agent: _.contains(user.access_rights, 'HOTEL_USER_AGENT'),
                external: _.contains(user.access_rights, 'HOTEL_USER_EXT'),
                superuser: _.contains(user.access_rights, 'HOTEL_USER_AGENT'),
                internalUser: _.contains(user.access_rights, 'HOTEL_USER_INTERNAL'),
                externalUser: _.contains(user.access_rights, 'HOTEL_USER_EXT')
            };
            container.is.internal = container.is.manager || container.is.agent || container.is.internalUser;
            container.can = {
                request_for_someone_else: container.is.manager
            };
            return container;
        }
        return service;
    }

})();
